module.exports = __webpack_public_path__ + "img/LPearlyBus.8dcad9ca.jpg";